<div class="smooth-scrolling s-consultation">
  <app-responsive-searchbar></app-responsive-searchbar>

  <!-- img-with-content START -->
  <section class="img-with-content">
    <div class="container">
      <div class="heading" data-aos="fade-up">
        <span class="light-txt">what’s in</span>
        <h1>consultation?</h1>
        <div class="contactLinks">
          <div class="link">
            <a href="#"><span class="icon"><img src="assets/images/video-black.svg"></span>video</a>
          </div>
          <div class="link">
            <a href="#"><span class="icon"><img src="assets/images/phone-black.svg"></span>phone</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 img-blk" data-aos="fade">
          <figure>
            <img src="assets/images/mobile-img.png" alt="">
          </figure>
        </div>
        <div class="col-md-6 desc-blk">
          <div class="steps">
            <div class="item" data-aos="fade-up">
              <div class="common-desc">
                <h2>Skin Assessment</h2>
                <p>Talk to us about your skin concerns, products you use, daily lifestyle habits, and skincare goals</p>
              </div>
            </div>
            <div class="item" data-aos="fade-up">
              <div class="common-desc">
                <h2>Expert Guidance</h2>
                <p>Get advice from our in-house experts in the form of personalised routines, specific ingredients, and
                  recommended products that suit your skin type and fit your budget</p>
              </div>
            </div>
            <div class="item" data-aos="fade-up">
              <div class="common-desc">
                <h2>Follow Up</h2>
                <p>We’re around to answer any follow-up queries and will also check-in to see how your skin is doing</p>
              </div>
            </div>
          </div>
          <div class="book-btn">
            <a href="#" class="cta-button">Book Now</a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- img-with-content END -->

  <!-- testimonials START -->
  <section class="testimonials">
    <div class="heading" data-aos="fade-up">
      <h3>testimonials</h3>
    </div>
    <div class="splide js_slides">
      <div class="box-Lists splide__track">
        <div class="boxes-Wrap splide__list">
          <div class="item splide__slide">
            <div class="bb-imgBox">
              <figure><img src="assets/images/s1.jpg" alt="" /></figure>
              <figure><img src="assets/images/s7.jpg" alt="" /></figure>
            </div>
            <div class="bb-descBox">
              <div class="rating">
                <img src="assets/images/star rating-black.svg">
              </div>
              <p>It’s the perfect pick-me-up</p>
              <div class="tag-blk"><a class="t-name" href="#">&#64;snehagarg</a></div>
            </div>
          </div>
          <div class="item splide__slide">
            <div class="bb-imgBox">
              <figure><img src="assets/images/s6.jpg" alt="" /></figure>
              <figure><img src="assets/images/s5.jpg" alt="" /></figure>
            </div>
            <div class="bb-descBox">
              <div class="rating">
                <img src="assets/images/star rating-black.svg">
              </div>
              <p>It’s the perfect pick-me-up</p>
              <div class="tag-blk"><a class="t-name" href="#">&#64;snehagarg</a></div>
            </div>
          </div>
          <div class="item splide__slide">
            <div class="bb-imgBox">
              <figure><img src="assets/images/s4.jpg" alt="" /></figure>
              <figure><img src="assets/images/s3.jpg" alt="" /></figure>
            </div>
            <div class="bb-descBox">
              <div class="rating">
                <img src="assets/images/star rating-black.svg">
              </div>
              <p>It’s the perfect pick-me-up</p>
              <div class="tag-blk"><a class="t-name" href="#">&#64;snehagarg</a></div>
            </div>
          </div>
          <div class="item splide__slide">
            <div class="bb-imgBox">
              <figure><img src="assets/images/s2.jpg" alt="" /></figure>
              <figure><img src="assets/images/s4.jpg" alt="" /></figure>
            </div>
            <div class="bb-descBox">
              <div class="rating">
                <img src="assets/images/star rating-black.svg">
              </div>
              <p>It’s the perfect pick-me-up</p>
              <div class="tag-blk"><a class="t-name" href="#">&#64;snehagarg</a></div>
            </div>
          </div>
          <div class="item splide__slide">
            <div class="bb-imgBox">
              <figure><img src="assets/images/s1.jpg" alt="" /></figure>
              <figure><img src="assets/images/s6.jpg" alt="" /></figure>
            </div>
            <div class="bb-descBox">
              <div class="rating">
                <img src="assets/images/star rating-black.svg">
              </div>
              <p>It’s the perfect pick-me-up</p>
              <div class="tag-blk"><a class="t-name" href="#">&#64;snehagarg</a></div>
            </div>
          </div>
          <div class="item splide__slide">
            <div class="bb-imgBox">
              <figure><img src="assets/images/s3.jpg" alt="" /></figure>
              <figure><img src="assets/images/s7.jpg" alt="" /></figure>
            </div>
            <div class="bb-descBox">
              <div class="rating">
                <img src="assets/images/star rating-black.svg">
              </div>
              <p>It’s the perfect pick-me-up</p>
              <div class="tag-blk"><a class="t-name" href="#">&#64;snehagarg</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- testimonials END -->
</div>
<!-- Footer START -->
<app-footer-bg></app-footer-bg>
<!-- Footer END -->